module.exports = __webpack_public_path__ + "img/world-1.95e35a54.png";